let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gUmln")).then(() => parcelRequire('71dfF'));